import blue from '@material-ui/core/colors/blue';
import styled from 'styled-components';

export const Title = styled.h2`
  font-size: 1.3em;
  font-weight: 600;
`;

export const ConfirmationCodeTitle = styled.p`
  text-align: center;
  margin-bottom: 0;
  margin-top: 30px;
  font-size: 1.2em;
  font-weight: 300;
`;

export const ActionLink = styled.div`
  text-align: center;
  margin-top: 30px;
  color: ${blue[500]};
  cursor: pointer;
  outline: none;
`;

export const CustomForm = styled.form`
  margin-top: 40px;
`;
